import moment from "moment-timezone";

import { OutputRow as MeetingRequestsData } from "api/getMeetingRequests";

export type Event = Pick<
	MeetingRequestsData,
	| "dateStartsUTC"
	| "dateEndsJustBeforeUTC"
	| "hostUid"
	| "guestUid"
	| "displayNameGuest"
	| "displayNameHost"
>;

export function formatBasicMeetingDetails(
	event: Event,
	currentUid: string,
	useShortFormat: boolean,
	timezone: string
) {
	const { dateStartsUTC, dateEndsJustBeforeUTC, hostUid, guestUid } = event;

	const start = moment(dateStartsUTC).tz(timezone);
	const end = moment(dateEndsJustBeforeUTC).tz(timezone);

	const partnersUid = hostUid === currentUid ? guestUid : hostUid;
	const partnersName =
		hostUid === currentUid ? event.displayNameGuest : event.displayNameHost;

	return {
		hostUid,
		guestUid,
		timezone,
		partnersName: partnersName ? partnersName : "(unknown)",
		identifier: `${event.hostUid}-${event.guestUid}-${start.format(
			"X"
		)}-${end.format("X")}`,
		partnersUid,
		startDate: start.format(
			useShortFormat ? "YYYY/MM/DD" : "dddd MMMM Do YYYY"
		),
		startTime: start.format("HH:mm"),
		endTime: end.format("HH:mm")
	};
}
